export const locale = {
    lang: "es-ES",
    data: {
        BILLING: {
            TITLE: "Facturación",
            LOADING: "Cargando...",
            SHOW_MORE: "Mostrar más",
            INVOICE: "Factura",
            BANK_SLIP: "Boleto Bancario",
            CREDIT_CARD: "Tarjeta de Crédito",
            PIX: "PIX",
            COUPON: "Cupón",
            REVIEW_NOTE: "Si la transacción fue rechazada por la operadora de la tarjeta, intente realizar la compra nuevamente.",
            STATUS: {
                PENDING: "Pendiente",
                BILLED: "Pagado",
                EXTERNALLY_PAID: "Pagado Externamente",
                CANCELED: "Cancelado",
                EXPIRED: "Expirado",
                DUE: "Vencido",
                REVIEW: "En Revisión"
            }
        }
    }
};